import React, { SyntheticEvent, useEffect, useState } from "react";
import Guarantee from "../../../types/entities/Guarantee";
import { Button, Form, FormInput, Header, Icon, Message, Modal, ModalActions, ModalContent, Popup, TextArea } from "semantic-ui-react";

interface Props {
    guarantee: Guarantee,
    submit: (event: SyntheticEvent, guaranteeId: string, solution: string) => void;
};

const GuaranteeCompleteModal = (props: Props) => {

    const [openModal, setOpenModal] = useState(false);
    const [solution, setSolution] = useState("");
    const [errorMessages, setErrorMessages] = useState<string[]>([]);

    const handleOpenModal = (event: SyntheticEvent) => {
        event.preventDefault();
        setOpenModal(true);
    };

    const handleCancelModal = (event: SyntheticEvent) => {
        event.preventDefault();
        setOpenModal(false);
    };

    useEffect(() => {
        if (props.guarantee) {
            const errorMessages = [];

            if (!props.guarantee.proofPayment) errorMessages.push(`Comprobante de pago: No se ha cargado un comprobante de pago.`);
            if (props.guarantee.guaranteeFiles.length < 2) errorMessages.push(`Evidencia: No se han cargado al menos 2 imagenes de evidencia.`);

            if (errorMessages.length > 0) {
                setErrorMessages(errorMessages);
            } else {
                setErrorMessages([]);
            }
        }
    }, [props.guarantee]);

    return (
        <Modal
            closeOnDimmerClick
            closeIcon={true}
            onClose={(event) => handleCancelModal(event)}
            open={openModal}
            trigger={
                <Popup
                    trigger={
                        <Button color="green" icon size="mini" onClick={(event) => handleOpenModal(event)}>
                            <Icon name="check" />
                        </Button>
                    }
                    content='Completar garantia'
                    position='bottom center'
                    size='small'
                    inverted
                />
            } >
            <Header icon="check circle outline" content="Marcar garantia como completada" />
            <ModalContent>

                {errorMessages.length > 0 && (
                    <Message
                        color="red"
                        size='small'
                        header={`Aviso importante`}
                        list={errorMessages}
                    />
                )}

                <Form>
                    <FormInput
                        control={TextArea}
                        label="Solución"
                        value={solution}
                        onChange={(event) => setSolution(event.target.value)}
                        placeholder="Escribe cual fue la solución o el trabajo realizado para completar esta garantia."
                    />
                </Form>
            </ModalContent>
            <ModalActions>
                <Button onClick={(event) => handleCancelModal(event)}>
                    <Icon name="cancel" /> Cerrar
                </Button>
                <Button color="green" onClick={(event) => props.submit(event, props.guarantee.id, solution)} disabled={errorMessages.length > 0 || !solution}>
                    <Icon name="checkmark" /> Completar
                </Button>
            </ModalActions>
        </Modal>
    );
};

export default GuaranteeCompleteModal;